import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Stack, Divider } from "@mui/material";
import QRCode from "react-qr-code";
import TopBar from "../components/TopBar";
import SongCard from "../components/SongCard";
import CustomButton from "../components/CustomButton";

import { firestore } from "../services/firebase";
import {
  collection,
  query,
  where,
  onSnapshot
} from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../services/firebase";

import Cookies from 'js-cookie';

import '../styles/QRCode.css'
import '../styles/EventImage.css'

const API_URL = process.env.REACT_APP_API_URL

const SingleEvent = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({});

  const { eventId } = useParams();
  const [imageSrc, setImageSrc] = useState("")
  const [bidList, setBidList] = useState([]);
  const [acceptedSong, setAcceptedSong] = useState(false)
  const [currentEvent, setCurrentEvent] = useState();
  const [showQRCode, setShowQRCode] = useState(false);
  const [cookiesSaved, setCookiesSaved] = useState(false)

  const handleShowQRCode = () => {
    setShowQRCode(prevState => !prevState);
  };

  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'ViewContent');
    }
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser)
      } else {
        setUser(currentUser)
      }
      if (!cookiesSaved){
        const allCookies = Cookies.get();
        fetch(`${API_URL}/firebase/save-cookies`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            cookies: allCookies,
          })
        }).then(() => {
          setCookiesSaved(true)
        })
      }
    })

    return () => unsubscribe()
  }, [])


  useEffect(() => {
    const showBids = async () => {
      const bids = query(
        collection(firestore, "Events", `${eventId}`, "Bids"),
        where("PaymentAccepted", "==", true)
      );
      const unsubscribe = onSnapshot(bids, (querySnapshot) => {
        const bidsData = [];

        querySnapshot.forEach((doc) => {
          bidsData.push(doc.data());
        });
        setBidList(bidsData);
      });
    };
    showBids();
  }, [eventId, acceptedSong]);

  useEffect(() => {
    const getEvent = async () => {
      await fetch(`${API_URL}/firebase/get-event`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          eventId: eventId,
        })
      }).then((res) => res.json())
      .then((res) => {
        const base64Image = res.EventImage;
        setImageSrc(`data:image/jpeg;base64,${base64Image}`);
        setCurrentEvent(res)
      })
    }
    getEvent();
  }, [eventId])

  const acceptSong = async (bidUID) => { // TODO: make this login in one API call
    await fetch(`${API_URL}/firebase/get-bid`, {
      method: "POST",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify({
        eventId: eventId,
        bidUID: bidUID
      }),
    }).then((res) => res.json())
    .then(async (bid) => {
      const paymentIntentId = bid.PaymentIntentId;

      await fetch(`${API_URL}/stripe/accept-payment-intent`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          paymentIntentId: paymentIntentId,
        }),
      }).then(async () => {
        await fetch(`${API_URL}/firebase/accept-bid`, {
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          body: JSON.stringify({
            eventId: eventId,
            bidUID: bidUID
          }),
        }).then(() => {
          setAcceptedSong(!acceptedSong)
        })
      });
    })
  }

  const rejectSong = async (bidUID) => { // TODO: make this login in one API call
    await fetch(`${API_URL}/firebase/get-bid`, {
      method: "POST",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify({
        eventId: eventId,
        bidUID: bidUID
      }),
    }).then((res) => res.json())
    .then(async (bid) => {
      const paymentIntentId = bid.PaymentIntentId;

      await fetch(`${API_URL}/stripe/cancel-payment-intent`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          paymentIntentId: paymentIntentId,
        }),
      }).then(async () => {
        await fetch(`${API_URL}/firebase/reject-bid`, {
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          body: JSON.stringify({
            eventId: eventId,
            bidUID: bidUID
          }),
        }).then(() => {
          setAcceptedSong(!acceptedSong)
        })
      });
    })
  }

  return (
    <Box className="max_container" sx = {{ marginTop: 8 }}>
      <TopBar/>
      <Divider color="gray" width="100%" sx = {{ marginTop: 4, marginBottom: 4 }}/>
      {
        imageSrc && imageSrc !== "data:image/jpeg;base64," &&
        <div className="image-container">
          <img src={imageSrc} alt="Event" className="logo-image"/>
        </div>
      }
      <Divider sx = {{ marginTop: 2 }}/>
      <Stack className="items-center ">
        {
          currentEvent !== undefined ? 
          <>
            <h3 className="text-2px uppercase font-medium text-white">{currentEvent.Name}</h3>
            <p>{currentEvent.Date}</p>
          </>
            :
          <></>
        }
        <button onClick={handleShowQRCode}>
          {showQRCode ? 'Hide QR Code' : 'Show QR Code'}
        </button>
        <div className={`content-wrapper ${showQRCode ? 'show' : 'hide'}`}>
          <Box className="text-center rounded-2xl p-5 mt-1 flex justify-center bg-white">
            <QRCode
              id="event-qr-code"
              title="Event QR Code"
              className="w-[225px] h-[225px] mt-2"
              value={window.location.href}
            />
          </Box>
        </div>
      </Stack>
      <Stack spacing={2} className="mt-4 px-12">
        <CustomButton 
          myFunction={() => navigate(`/Events/${eventId}/RequestSong`)}
          text={"Request Song"}
        />
      </Stack>
      <Stack className="px-2 mt-[50px]">
        <h3 className="uppercase font-medium text-white mb-2">Queue</h3>
        <Divider color="gray" width="100%" />
        {
          currentEvent && currentEvent.Creator ? 
          bidList
          .filter((bid) => !bid.Accepted)
          .sort((x, y) =>
            parseInt(x.Likes, 10) < parseInt(y.Likes, 10) ? 1 : -1
          )
          // .sort((x, y) =>
          //   parseInt(x.Amount, 10) < parseInt(y.Amount, 10) ? 1 : -1
          // )
          .map((bid) => (
            <SongCard 
              bid={bid}
              creator={currentEvent.Creator}
              acceptSong={acceptSong}
              rejectSong={rejectSong}
            />
          ))
          :
          <></>
        }
      </Stack>
      <Stack className="pb-5 px-2 mt-[50px]">
        <h3 className="uppercase font-medium text-white mb-2">Accepted Songs</h3>
        <Divider color="gray" width="100%" />
        
        {
          currentEvent && currentEvent.Creator ? 
          bidList
          .filter((bid) => bid.Accepted)
          // .sort((x, y) =>
          //   parseInt(x.Amount, 10) < parseInt(y.Amount, 10) ? 1 : -1
          // )
          .sort((x, y) =>
            parseInt(x.Likes, 10) < parseInt(y.Likes, 10) ? 1 : -1
          )
          .map((bid) => (
            <SongCard 
              bid={bid}
              creator={currentEvent.Creator}
              acceptSong={acceptSong}
            />
          ))
          :
          <></>
        }
        {
          user && currentEvent && currentEvent.Creator &&  currentEvent.Creator === user.email ? 
          <Stack spacing={2} className="mt-12 px-12">
            <CustomButton 
              myFunction={() => navigate(`/Events/${eventId}/EventSettings`)}
              text={"Event Settings"}
            />
          </Stack>
          :
          <></>
        }
      </Stack>
    </Box>
  );
};

export default SingleEvent;